import React, { useEffect } from "react";
import cx from "classnames";
import { Icon } from "../Icon/Icon";
import s from "./XCircleLoader.module.scss";
import { useSetIsLoaderXCircle } from "stores/loadingStateStore";

type XCircleLoaderProps = {
  classNames?: string;
};

export const XCircleLoader = ({ classNames = "" }: XCircleLoaderProps) => {
  const setIsLoaderXCircle = useSetIsLoaderXCircle();

  useEffect(() => {
    setIsLoaderXCircle(true);
    return () => setIsLoaderXCircle(false);
  }, [setIsLoaderXCircle]);

  return (
    <div
      className={cx(
        "d-flex justify-content-center align-items-center flex-grow-1",
        classNames,
      )}
    >
      <div
        className={cx(
          "d-flex justify-content-center align-items-center",
          s.loader,
        )}
        data-testid="x-circle-loader"
      >
        <svg
          className={s.svg}
          viewBox="0 0 50 50"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle className={s.path} cx="25" cy="25" r="20" fill="none" />
        </svg>
        <Icon
          iconName="spinner-trox-X-logo"
          className="position-absolute icon-64 text-gray-300 z-1"
        />
      </div>
    </div>
  );
};
